import React from "react";
import { Redirect } from "react-router-dom";

export default class ErrorWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.log("❌", error);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <Redirect to="/500" />;
    }
    return this.props.children;
  }
}
